/* eslint-disable no-nested-ternary */
import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Scrollable from '../Scrollable';
import { useBreakpoints } from 'utils/hooks';

import './main.scss';

function Main({ sidebar = null, main = null }) {
  const isMobileView = !useBreakpoints().md;
  const [opened, setOpened] = useState(false);
  const closeMenu = () => setOpened(false);
  return (
    <div className="app-main">
      {sidebar && (
        <div
          className="app-main-sidenav"
          style={{
            minWidth: isMobileView && sidebar ? (opened ? '100%' : 0) : '',
            width: isMobileView && sidebar ? (opened ? '100%' : 0) : '',
            opacity: isMobileView && sidebar && !opened ? 0 : 1,
          }}
        >
          {isMobileView && opened && sidebar && (
            <span
              className="icon_close app-main-sidenav-action"
              onClick={() => setOpened(false)}
            />
          )}
          <Scrollable>
            {sidebar && React.cloneElement(sidebar, { closeMenu }, null)}
          </Scrollable>
        </div>
      )}
      <div
        className="app-main-container"
        style={{ width: isMobileView && opened ? 0 : '100%' }}
      >
        {isMobileView && !opened && sidebar && (
          <i
            className="icon_menu app-main-sidenav-action"
            onClick={() => setOpened(true)}
          />
        )}
        <Scrollable>{main}</Scrollable>
      </div>
    </div>
  );
}

Main.propTypes = {
  sidebar: PropTypes.node,
  main: PropTypes.node,
};

export default Main;
